import { HttpHandlerFn, HttpRequest, HttpResponse } from '@angular/common/http';
import { BehaviorSubject, delayWhen, interval } from 'rxjs';
import { tap } from 'rxjs';

// A BehaviorSubject to hold the loading state
const loadingSubject = new BehaviorSubject<boolean>(false);
// delay added to solve expressioHasChangedError.
// when the request is fast the value is being changed almost immediately, that causes the issue with template
export const loading$ = loadingSubject
  .asObservable()
  .pipe(delayWhen((isLoading) => (isLoading ? interval(0) : interval(100)))); // Observable to be used in templates

export function loadingInterceptor(
  req: HttpRequest<unknown>,
  next: HttpHandlerFn,
) {
  let xhrCreations = 0;
  let xhrResolutions = 0;

  // Function to update the loading status
  function updateLoadingStatus() {
    const isLoading = xhrResolutions < xhrCreations;
    // added condition to NOT change the value and trigger observable if value is not changed (for consecutive requests)
    if (loadingSubject.value !== isLoading) {
      loadingSubject.next(isLoading); // Update the loading state
    }
  }

  // Determine if the loading state should be shown for this request
  function shouldShowLoading(req: HttpRequest<any>): boolean {
    const params = req.params;
    const data = req.body;
    return !(params?.get('silent') || data?.silent); // Avoid loading if 'silent' param/data exists
  }

  // If we should show loading, increment the creation count
  if (shouldShowLoading(req)) {
    xhrCreations++;
    updateLoadingStatus();
  }

  return next(req).pipe(
    tap({
      next: (event) => {
        if (event instanceof HttpResponse) {
          // When a response is received, resolve the loading state
          xhrResolutions++;
          updateLoadingStatus();
        }
      },
      error: () => {
        // In case of error, resolve loading state as well
        xhrResolutions++;
        updateLoadingStatus();
      },
    }),
  );
}
